export default {
    namespaced: true,
    state: {
      messages: [
        {
          id: 100,
          author: 'Amt für Ausbildungsförderung Augsburg',
          read: false,
          date: '08.02.2019',
          time: '16:32 Uhr',
          for: [100,101],
          subject: 'Ihr Antrag auf Ausbildungsförderung (BAföG) ist eingegangen',
          message: `Sehr geehrter Herr Mustermann,

          Hiermit bestätigen wir Ihnen den Eingang Ihres Antrags auf Ausbildungsförderung (BAföG) für Studenten.
          Ihr Antrag wird aktuell geprüft und ggf. bearbeitet. Sobald sich dieser Status ändert, werden wir es Ihnen natürlich umgehend mitteilen. 
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.
          `,
        },
        {
            id: 101,
            author: 'Bürgerbüro Stadtmitte',
            read: false,
            date: '08.02.2019',
            time: '13:12 Uhr',
            for: [100],
            subject: 'Erneuerung Ihres Reisepasses',
            message: `Guten Tag Herr Mustermann,
            
            Ihr Reisepass läuft in wenigen Monaten aus. Wir können Ihnen mit Ihren Daten aus dem Bürgerkonto einen neuen Reisepass zusenden. Prüfen Sie daher noch einmal dafür relevanten Angaben wie Ihre Anschrift und bringen Sie diese ggf. auf den neuesten Stand.
            
            Mit freundlichen Grüßen,
            Ihr Bürgerbüro Stadtmitte`
        },
        {
            id: 102,
            author: 'Agentur für Arbeit',
            read: true,
            date: '08.02.2019',
            time: '16:32 Uhr',
            for: [100,101],
            subject: 'Lorem ipsum dolor sit',
            message: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.',
        },
        {
            id: 103,
            author: 'Standesamt Augsburg',
            read: true,
            date: '08.02.2019',
            time: '16:32 Uhr',
            for: [100],
            subject: 'Augsburg wird digital',
            message: `Sehr geehrter Herr Mustermann,
 
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.
            `,
        },
        {
            id: 104,
            author: 'Landratsamt Augsburg',
            read: true,
            date: '08.02.2019',
            time: '16:32 Uhr',
            for: [101],
            subject: 'Lorem ipsum dolor sit',
            message: `Sehr geehrter Herr Mustermann,
 
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.
            `,
        },
        {
            id: 105,
            author: 'Straßenverkehrsamt Augsburg',
            read: true,
            date: '08.02.2019',
            time: '16:32 Uhr',
            for: [100],
            subject: 'Verkehrseinschränkungen in der Näher ihres Wohnortes',
            message: `Sehr geehrter Herr Mustermann,
 
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.
            `,
        },
      ]
    },
    mutations: {
        SET_MESSAGE_READ (state, id) {
            const message = state.messages.find(message => message.id == id);
            if(!message.read) {
                message.read = true;
            }
        },
        DELETE_MESSAGE (state, id) {
            const message = state.messages.find(message => message.id == id);
            const messageIndex = state.messages.indexOf(message);
            if(messageIndex > -1) {
                console.log(state.messages);
                state.messages.splice(messageIndex, 1);
                console.log(state.messages);
            }
        },
    },
    actions: {
        checkMessage({ commit, state }, id) {
            const message = state.messages.find(message => message.id == id);
            if(message) {
                commit('SET_MESSAGE_READ', id);
            }
        },
        deleteMessage({ commit }, id) {
            commit('DELETE_MESSAGE', id);
        },
    },
    getters: {
      getAllMessages: state => {
        return state.messages;
      },
      getMessageById: (state) => (id) => {
        return state.messages.find(message => message.id == id);
      },
      getMessagesByIds: (state) => (ids) => {
        return state.messages.filter(message => message.for.includes(ids));
      },
      getUnreadMessages: (state) => (id) => {
        return state.messages.filter(message => message.for.includes(ids) && !message.read);
      },
      getMessagesByTitle: state => (searchTerm) => {
        return state.messages.filter(message => message.author.toLowerCase().includes(searchTerm.toLowerCase()) 
        || message.subject.toLowerCase().includes(searchTerm.toLowerCase()));
      }
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/messages.js